import AllProductsPage from './AllProducts';

export default AllProductsPage;
